﻿export class WorkflowDefinition {
    workflowDefinitionId: string;
    definitionName: string;
    definitionVersion: string;
    definitionTitle: string;
    definitionDescription: string;
    creationDate: string;
    lastModifiedDate: string;
    documentDefinition: string;
    validationRules: string;
    versionId: string;
    isPublished: boolean;
    displayIndex: number;
    hidden: boolean;
}